import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
  import { Observable ,  throwError as throwError, BehaviorSubject } from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import Swal from 'sweetalert2';
 import { NEW_URL_SERVICIOS_ERPFAC_PUB } from  '../../config/config';

@Injectable()
export class LoginempresaService {

  private lsDocumento = new BehaviorSubject<any>(undefined); //INYECCION DE DEPENCIA
 
  constructor(public http: HttpClient ,) {
     }

     listarTipoDocumentosPublicos(sutipodocumento){
    let url = NEW_URL_SERVICIOS_ERPFAC_PUB + 'documentocliente/listarTipoDocumentosPublicos';
    return this.http.post( url,sutipodocumento )
              .pipe(map( (resp: any) => { 
                return resp;
              } ),catchError((err: HttpErrorResponse) => {
                 const Toast =  Swal.mixin({
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000,
                //  timerProgressBar: true ,
                  didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                  }
                }); 
                Toast.fire({
                  icon: 'warning',
                  title: 'Error en el servicio '+err.message
                })
                
                return throwError(() => err);
              }));
  }
 
 
  
  retornaDocumentoPublico(documento){
    let url = NEW_URL_SERVICIOS_ERPFAC_PUB + 'documentocliente/retornaDocumentoPublico';
    return this.http.post(url, documento)
      .pipe(map( (resp: any) => {
        this.lsDocumento.next(resp);
        return resp;
      }),catchError((err: HttpErrorResponse) => {
        const Toast =  Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        //  timerProgressBar: true ,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        }); 
        Toast.fire({
          icon: 'warning',
          title: 'Error en el servicio '+err.message
        })      
          return throwError(() => err);
      }));
  }
   

  descargapdfdocumento(obj) {
          
    const url = NEW_URL_SERVICIOS_ERPFAC_PUB + 'documentocliente/descargapdfdocumento';
    return this.http.post(url,obj, {
      responseType: "arraybuffer"
    }).pipe(map( (resp: any) => { 
      return resp;
    } ),catchError((err: HttpErrorResponse) => {
      const Toast =  Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      //  timerProgressBar: true ,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      }); 
      Toast.fire({
        icon: 'warning',
        title: 'Error en el servicio '+err.message
      })    
        return throwError(() => err);
    }));
  }

    
  descargarDocumentoCPE(descarga_cpe) {
    let url = NEW_URL_SERVICIOS_ERPFAC_PUB + 'documentocliente/descargarDocumentoCPE';
    return this.http.post( url,descarga_cpe )
              .pipe(map( (resp: any) => {
                return resp;
              } ),catchError((err: HttpErrorResponse) => {
                const Toast =  Swal.mixin({
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000,
                //  timerProgressBar: true ,
                  didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                  }
                }); 
                Toast.fire({
                  icon: 'warning',
                  title: 'Error en el servicio '+err.message
                })             
                   return throwError(() => err);
              }));
  }

 
  
}
 